import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OutsourcingSecurity5 = props => (
    <section id="outsourcing-security-section5" className="my pt-5">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 fw-600 mb-5">{props.t('services:outsourcingSecurity:section-5.title')}</h2>
            {[1, 2, 3].map(item => (
                <div key={item} className={item < 3 ? 'mb-5' : ''}>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingSecurity:section-5.' + item + '.title')}</h3>
                    </div>
                    <p className={item < 3 ? '' : 'm-0'}>{props.t('services:outsourcingSecurity:section-5.' + item + '.text')}</p>
                </div>
            ))}
        </Container>
    </section>
);

export default OutsourcingSecurity5;
